
export default [
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'copiar',
        label: 'Copiar Medições e Funções do seguinte GHE',
        option: {
            key: 'id',
            label: 'ghe',
            value: 'id'
        },
        info: 'Selecione um GHE para copiar as medições e funções já cadastradas.',
        rules: ['']
    },
];




// WEBPACK FOOTER //
// ./src/components/apps/web/ltcat/ghe/_form/ltcat-ghe-cadastrar.js